{
  "U70": "#66AECA",
  "U71": "#43C7F3",
  "U72": "#23BDC6",
  "U73": "#416AB3",
  "U75": "#1F91C0",
  "U76": "#106AB5",
  "U77": "#6891CB",
  "U78": "#1A98D6",
  "U79": "#219E95",
  "U80": "#006061",
  "U81": "#68908C",
  "U83": "#164899"
}
